<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Informe de Recaudador</h3>
      </div>
      <div class="layout__controls">
        <div class="form-inline">
          <button type="button" @click="consultar" class="btn-info">
            <i class="fa fa-search"></i><span>Consultar</span>
          </button>
          <button
            type="button"
            @click="mostrarHistoricos"
            class="btn-secondary"
          >
            <i class="fa fa-history"></i><span>Historial</span>
          </button>
          <button type="button" @click="exportarExcel" class="btn-success">
            <i class="fa fa-file-excel-o"></i><span>Excel</span>
          </button>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card__title">
        <h5>Filtros de la consulta</h5>
      </div>
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12 col-md-4">
            <div class="form-field">
              <div class="datepicker-field">
                <VueCtkDateTimePicker
                  id="desde"
                  v-model="form.fecha"
                  locale="es"
                  only-date
                  no-label
                  button-now-translation="Ahora"
                  format="YYYY-MM-DD"
                  formatted="YYYY-MM-DD"
                  label="Seleccione fecha..."
                />
                <label>Fecha</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-4">
            <div class="form-field select2 select2-field--stretch">
              <div class="select2-field">
                <v-select
                  :filterable="false"
                  @input="inputBodega"
                  label="descripcion"
                  placeholder="Seleccione..."
                  :options="bodegas"
                  id="bodegas"
                  v-model="selectedBodega"
                ></v-select>
                <label for="bodegas">Sucursal</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-4">
            <div class="form-field select2">
              <div class="select2-field">
                <v-select
                  placeholder="Seleccione..."
                  id="recaudador_id"
                  v-model="selectedRecaudador"
                  :options="recaudadores"
                  @search="searchRecaudadores"
                  @input="inputRecaudador"
                  label="nombre"
                ></v-select>
                <label for="recaudador_id">Recaudador</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-4">
            <div class="form-field select2">
              <div class="select2-field">
                <v-select
                  placeholder="Seleccione..."
                  @search="onSearchRuta"
                  @input="inputRuta"
                  id="ruta_id"
                  :options="rutas"
                  label="descripcion"
                  v-model="selectedRuta"
                ></v-select>
                <label for="ruta_id">Ruta</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card__title">
        <h5>Resultados de la consulta</h5>
      </div>
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12">
            <div style="max-height: 300px" class="table-responsive">
              <table class="custom-table">
                <thead>
                  <tr>
                    <th>No.</th>
                    <th># Cartilla</th>
                    <th>Fecha de último abono</th>
                    <th>Nombre del cliente</th>
                    <th>Teléfono</th>
                    <th>Valor estimado a cobrar</th>
                    <th>Saldo actual</th>
                    <th>Abono</th>
                    <th>Saldo</th>
                    <th>Premio</th>
                    <th>Devolución</th>
                    <th>Cambio(+)</th>
                    <th>Cambio(-)</th>
                    <th># Comprobante de pago</th>
                    <th>Observación</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-show="cobranzas.length === 0">
                    <td colspan="14">
                      <strong>No se ha encontrado datos.</strong>
                    </td>
                  </tr>
                  <tr v-for="(cobranza, key) in cobranzas" :key="key">
                    <td>
                      {{ key + 1 }}
                    </td>
                    <td>
                      {{ cobranza.numero_documento }}
                    </td>
                    <td>
                      {{ cobranza.fecha_ultimo_abono }}
                    </td>
                    <td>
                      {{ cobranza.nombre_cliente }}
                    </td>
                    <td>
                      {{ cobranza.telefonos }}
                    </td>
                    <td>
                      {{ moneyFormat(cobranza.valor_estimado) }}
                    </td>
                    <td>
                      {{ moneyFormat(cobranza.saldo_actual) }}
                    </td>
                    <td>
                      {{ moneyFormat(cobranza.valor_abono) }}
                    </td>
                    <td>
                      {{ moneyFormat(cobranza.saldo) }}
                    </td>
                    <td>
                      {{ cobranza.premio }}
                    </td>
                    <td>
                      {{ cobranza.devolucion }}
                    </td>
                    <td>
                      {{ cobranza.cambio_in }}
                    </td>
                    <td>
                      {{ cobranza.cambio_sa }}
                    </td>
                    <td>
                      {{ cobranza.numero_comp_pago }}
                    </td>
                    <td>
                      {{ cobranza.observacion }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12">
            <h5>Cuadre de mercadería</h5>
            <div style="max-height: 300px" class="table-responsive">
              <table class="custom-table">
                <thead>
                  <tr>
                    <th>Mercadería</th>
                    <th>Cantidad inicial</th>
                    <th>Ingreso (+) Devolución</th>
                    <th>Ingreso (+) Cambios</th>
                    <th>Ingreso Total</th>
                    <th>Salida (-) Cambios</th>
                    <th>Salida (-) Ventas</th>
                    <th>Salida (-) Premios</th>
                    <th>Salida Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr :key="index" v-for="(cuadre, index) in cuadreMercaderia">
                    <td>
                      {{ cuadre.descripcion_item }}
                    </td>
                    <td>
                      {{ parseInt(cuadre.cantidad_inicial) }}
                    </td>
                    <td>
                      {{ parseInt(cuadre.devoluciones) }}
                    </td>
                    <td>
                      {{ parseInt(cuadre.cambios_devoluciones) }}
                    </td>
                    <td>
                      {{ parseInt(cuadre.total_ingresos) }}
                    </td>
                    <td>
                      {{ parseInt(cuadre.cambios_aumentos) }}
                    </td>
                    <td>
                      {{ parseInt(cuadre.aumentos) }}
                    </td>
                    <td>
                      {{ parseInt(cuadre.premios) }}
                    </td>
                    <td>
                      {{ parseInt(cuadre.total_egresos) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal
      name="historicos"
      height="auto"
      width="70%"
      scrollable
      adaptive
      resizable
      reset
    >
      <reportes-historicos-excel tipoReporte="cr"></reportes-historicos-excel>
    </modal>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      selectedRecaudador: this.defaultRecaudador,
      selectedRuta: this.defaultRuta,
      rutas: [],
      recaudadores: [],
      form: {
        fecha: this.defaultFecha,
        recaudador_id: this.defaultRecaudador != null?this.defaultRecaudador.id:'',
        ruta_id: this.defaultRuta != null?this.defaultRuta.id:'',
        exportar: "N",
        bodega_id: this.defaultBodega != null?this.defaultBodega.id:'',
      },
      cobranzas: [],
      cuadreMercaderia: [],
      moneyFormat: moneyFormat,
      selectedBodega: this.defaultBodega,
    };
  },
  props: {
      defaultBodega: {
        type: Object,
        required: false,
        default: function () {
          return null;
        }
      },
      defaultRuta: {
        type: Object,
        required: false,
        default: function () {
          return null;
        }
      },
      defaultRecaudador: {
        type: Object,
        required: false,
        default: function () {
          return null;
        }
      },
      defaultFecha: {
        required: false,
        type: String,
        default: ''
      },
      bodegas: {
        type: Array,
        required: false,
        default: function () {
          return [];
        },
      },
    },
  methods: {
    inputBodega: function () {
      if (this.selectedBodega != null)
        this.form.bodega_id = this.selectedBodega.id;
      else this.form.bodega_id = "";
    },
    serialize: function (obj) {
      return (
        "?" +
        Object.keys(obj)
          .reduce(function (a, k) {
            let val = obj[k];
            let esArray = false;
            if (val instanceof Date) {
              val = val.toLocaleDateString("en");
            } else if (val instanceof Array) {
              esArray = true;
              let acumulador = "";
              for (let i = 0; i < val.length; i++) {
                acumulador += k + "%5B%5D=" + val[i];
                if (i != val.length - 1) {
                  acumulador += "&";
                }
              }
              val = acumulador;
              a.push(val);
            }
            if (!esArray) a.push(k + "=" + encodeURIComponent(val));
            return a;
          }, [])
          .join("&")
      );
    },
    exportarExcel: function () {
      this.form.exportar = "S";
      window.open(
        url + "/reporte-cobranza" + this.serialize(this.form),
        "_blank"
      );
    },
    consultar: function () {
      this.form.exportar = "N";
      if (this.selectedRecaudador != null && this.selectedRuta != null) {
        axios
          .get(url + "/reporte-cobranza", {
            params: this.form,
          })
          .then(({ data }) => {
            this.cuadreMercaderia = data.cuadreMercaderia;
            this.cobranzas = data.cobranza;
          })
          .catch(({ response }) => {
            if (response.status === 404) {
              swal(
                "No existe una recaudación para la fecha indicada.",
                "Aviso",
                "warning"
              );
            } else swal("Hubo un error, intente nuevamente.", "Error", "error");
          });
      } else {
        swal("Debe seleccionar un recaudador y una ruta.", "Aviso", "warning");
      }
    },
    mostrarHistoricos: function () {
      this.$modal.show("historicos");
    },
    inputRecaudador: function () {
      if (this.selectedRecaudador != null)
        this.form.recaudador_id = this.selectedRecaudador.id;
      else this.form.recaudador_id = "";
    },
    inputRuta: function () {
      if (this.selectedRuta != null) this.form.ruta_id = this.selectedRuta.id;
      else this.form.ruta_id = "";
    },
    searchRecaudadores: function (search, loading) {
      loading(true);
      let that = this;
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        if (
          (this.readyState == 4 && this.status == 200) ||
          this.status == 201
        ) {
          let json = JSON.parse(this.responseText);
          that.recaudadores = json;
          loading(false);
        } else loading(false);
      };
      xmlhttp.open(
        "GET",
        url + "/search/usuarios?tipo=R&bodega_id=" + this.form.bodega_id  + "&search=" + search,
        true
      );
      xmlhttp.send();
    },
    onSearchRuta: function (search, loading) {
      loading(true);
      let that = this;
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        if (
          (this.readyState == 4 && this.status == 200) ||
          this.status == 201
        ) {
          let json = JSON.parse(this.responseText);
          that.rutas = json;
          loading(false);
        } else loading(false);
      };
      xmlhttp.open("GET", url + "/search/rutas?bodega_id=" + this.form.bodega_id  + "&search=" + search, true);
      xmlhttp.send();
    },
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/logistica/pedidos/ReporteCobranza.vue